import { useState } from "react";
import { db, storage } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function ReportForm() {
  const [form, setForm] = useState({
    tipo: "perdido",
    descripcion: "",
    lugar: "",
    contacto: "",
    mobile: "",
    imagen: null,
    resuelto: false,
    fechaObjeto: "",
  });
  const [subiendo, setSubiendo] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files && files.length > 0 ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubiendo(true);
    let url = "";

    try {
      // Subir imagen si existe
      if (form.imagen && form.imagen instanceof File) {
        const safeName = form.imagen.name.replace(/\s+/g, "_");
        const storageRef = ref(storage, `objetos/${Date.now()}_${safeName}`);
        await uploadBytes(storageRef, form.imagen);
        url = await getDownloadURL(storageRef);
      }

      // Guardar reporte sin usuario logueado
      await addDoc(collection(db, "objetos"), {
        tipo: form.tipo,
        descripcion: form.descripcion.trim(),
        lugar: form.lugar.trim(),
        contacto: form.contacto.trim(),
        mobile: form.mobile.trim(),
        imagen: url,
        fecha: new Date().toLocaleDateString(),
        timestamp: serverTimestamp(),
        resuelto: false,
        //reportadoPor: form.contacto.trim(),
        fechaObjeto: form.fechaObjeto || "",
      });

      setMensaje("¡Objeto reportado con éxito!");
      setForm({
        tipo: "perdido",
        descripcion: "",
        lugar: "",
        contacto: "",
        mobile: "",
        imagen: null,
        resuelto: false,
        fechaObjeto: "",
      });
    } catch (error) {
      console.error("Error al subir el objeto:", error);
      setMensaje("Error al subir el objeto. Intenta nuevamente.");
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white p-4 sm:p-6 rounded-2xl shadow-md space-y-4"
    >
      <h2 className="text-xl font-bold">Reportar objeto</h2>
      <p>
        Marcá si es perdido o encontrado, una breve descripción y tus datos.
      </p>

      {/* Tipo */}
      <div className="mt-4">
        <div className="flex gap-4">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="tipo"
              value="perdido"
              checked={form.tipo === "perdido"}
              onChange={handleChange}
            />
            Perdido
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="tipo"
              value="encontrado"
              checked={form.tipo === "encontrado"}
              onChange={handleChange}
            />
            Encontrado
          </label>
        </div>
      </div>

      {/* Campos */}
      <div className="mt-4 space-y-4">
        <input
          type="date"
          name="fechaObjeto"
          placeholder="Día"
          value={form.fechaObjeto}
          onChange={handleChange}
          className="calendar border px-3 py-2 rounded w-full"
        />
        <input
          type="text"
          name="lugar"
          placeholder="Lugar"
          value={form.lugar}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
        <textarea
          name="descripcion"
          placeholder="Descripción"
          value={form.descripcion}
          onChange={handleChange}
          required
          className="w-full border px-3 py-2 rounded"
        />
        <input
          type="text"
          name="contacto"
          placeholder="Tu nombre"
          value={form.contacto}
          onChange={handleChange}
          required
          className="w-full border px-3 py-2 rounded"
        />
        <input
          type="tel"
          name="mobile"
          placeholder="Tu móvil (ej: 11XXXXXXXX)"
          value={form.mobile}
          onChange={handleChange}
          required
          maxLength={10}
          minLength={10}
          className="w-full border px-3 py-2 rounded"
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleChange}
          name="imagen"
          className="upload w-full"
        />
      </div>

      {/* Botón */}
      <button
        type="submit"
        disabled={subiendo}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full"
      >
        {subiendo ? "Subiendo..." : "Enviar"}
      </button>

      {mensaje && <p className="text-center text-green-600">{mensaje}</p>}
    </form>
  );
}
